import { useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Lightweight SEO helper to set document title and meta description.
 * Avoids adding extra dependencies while keeping per-page metadata fresh.
 */
const SEO = ({ title, description }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
  }, [title, description]);

  return null;
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default SEO;
